// extracted by mini-css-extract-plugin
export default {"ProductTileList":"ProductTileList-module__ProductTileList--spEi"};